export const itemContainerSx = {
  display: 'block',
  position: 'relative',
  verticalAlign: 'top',
  mb: 1,
  mr: 1,
};

export const itemDividerSx = {
  borderBottom: 1,
  borderColor: 'divider',
  '&:last-of-type': {
    borderBottom: 'none',
  },
};

export const trackSeparatorSx = {
  borderBottom: 1,
  borderColor: 'divider',
  mb: '12px',
  '&:last-of-type': {
    borderBottom: 'none',
    mb: 0,
  },
};
